var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.value == 'number')?_c('span',[(_vm.small)?_c('b-icon-record-fill',{attrs:{"variant":_vm.variant(_vm.value)}}):_c('b-badge',{attrs:{"variant":_vm.variant(_vm.value)}},[_vm._v(_vm._s(_vm.value))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }